import { SvgElement, type SvgElementProps } from '@axinom/mosaic-ui';
import React from 'react';

const DEFAULT_PATH_PROPS = {
  vectorEffect: 'non-scaling-stroke' as const,
  fill: 'none',
  strokeWidth: '2',
};

export const ConflictIcon: React.FC<SvgElementProps> = (props) => (
  <SvgElement {...props}>
    <path
      {...DEFAULT_PATH_PROPS}
      stroke="#FFC81A"
      d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20,10.1,2,20,2ZM20,10.1v13.7h0v-13.7ZM20,29.9v-2.6h0v2.6Z"
    />
  </SvgElement>
);

export const CreateIcon: React.FC<SvgElementProps> = (props) => (
  <SvgElement {...props}>
    <path
      {...DEFAULT_PATH_PROPS}
      stroke="#B7B7B7"
      d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20,10.1,2,20,2ZM20,11.5v17h0V11.5ZM11.5,20h17H11.5Z"
    />
  </SvgElement>
);

export const OverwriteIcon: React.FC<SvgElementProps> = (props) => (
  <SvgElement {...props}>
    <path
      {...DEFAULT_PATH_PROPS}
      stroke="#FFC81A"
      d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20,10.1,2,20,2ZM13.4,24.6c-2.6-3.6-1.7-8.7,1.9-11.3,2.9-2,6.7-2,9.5.1M14.9,19.2l-1.5,5.4-5.4-1.6M24.4,20.9l2.7-4.9,4.9,2.7M27.1,16c2.2,3.9.9,8.8-2.9,11-2.6,1.5-5.8,1.5-8.3-.1"
    />
  </SvgElement>
);

export const ProtectedIcon: React.FC<SvgElementProps> = (props) => (
  <SvgElement {...props}>
    <path
      {...DEFAULT_PATH_PROPS}
      stroke="#B7B7B7"
      d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20,10.1,2,20,2ZM27.2,18.4h-14.5v9.8h14.5v-9.8ZM24.1,18.4v-4.1c0-2-1.5-3.7-3.4-3.7h-1.1c-1.9,0-3.4,1.6-3.4,3.7v4.1M20,22.6c-.5,0-.9.4-.9,1s.4,1,.9,1,.9-.4.9-1-.4-1-.9-1Z"
    />
  </SvgElement>
);

export const SkipIcon: React.FC<SvgElementProps> = (props) => (
  <SvgElement {...props}>
    <path
      {...DEFAULT_PATH_PROPS}
      stroke="#FFC81A"
      d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20,10.1,2,20,2ZM12.5,13.8l6.2,6.2-6.2,6.2M21.3,13.8l6.2,6.2-6.2,6.2"
    />
  </SvgElement>
);

export const UnprotectedIcon: React.FC<SvgElementProps> = (props) => (
  <SvgElement {...props}>
    <path
      {...DEFAULT_PATH_PROPS}
      stroke="#B7B7B7"
      d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20,10.1,2,20,2Z"
    />
  </SvgElement>
);
